import { render, staticRenderFns } from "./CompanyStaffNewPage.vue?vue&type=template&id=93d77b06&"
import script from "./CompanyStaffNewPage.vue?vue&type=script&lang=ts&"
export * from "./CompanyStaffNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports